import { ParticipantSalle } from '../../../core/services/salle-appel.service';
import { degradeAvatar, initiale } from './avatars-appel';

/** Un participant tel que les ecrans d'appel le dessinent : etat de la salle + nom, initiale et teinte. */
export interface TuileAppel extends ParticipantSalle {
  nom: string;
  initiale: string;
  degrade: string;
  /** Photo de profil, quand la personne en a une ; sinon les initiales. */
  photo?: string;
}

/**
 * Habille les participants de la salle pour l'ecran.
 *
 * L'identite LiveKit est l'identifiant de l'utilisateur ; le NOM vient du poste (collegues
 * de la conversation, interlocuteur de l'appel). Faute de nom connu, un libelle neutre —
 * jamais l'identifiant brut, qui ne dit rien a la personne en face.
 *
 * Soi-meme reste en tete. Un participant qui parle n'est PAS remonte : l'ordre suit
 * l'arrivee, pour que les tuiles ne sautent pas pendant la conversation.
 */
export function construireTuiles(
  participants: readonly ParticipantSalle[],
  nomDe: (identity: string) => string | undefined,
  monNom: string,
  nomInconnu: string,
  libelleMoi: string,
  photoDe?: (identity: string) => string | undefined,
  maPhoto?: string,
): TuileAppel[] {
  return participants.map((p) => {
    const nom = p.moi ? monNom.trim() || libelleMoi : nomDe(p.identity)?.trim() || nomInconnu;
    const photo = p.moi ? maPhoto : photoDe?.(p.identity);
    return { ...p, nom, initiale: initiale(nom), degrade: degradeAvatar(nom), ...(photo ? { photo } : {}) };
  });
}
